export const isValidUrl = (str) => {
    try {
        const pattern = /^(https?:\/\/)?([\w\-]+\.)+[a-z]{2,6}(:\d+)?(\/.*)?$/i;
        return pattern.test(str);
    } catch(e){
        console.error(e);
        return false;
    }
  }
  